import React, { Dispatch, useEffect } from 'react';

// styles
import {
  CardExpireDate,
  CardOperatorAndNumber,
  CardOperatorImageContainer,
  Label,
  SavedCardInfo,
  StyledDeleteIcon,
  Wrapper,
} from './SavedCreditCards.styled';
import { trashOutline } from 'ionicons/icons';
import { useIonAlert } from '@ionic/react';
import RadioButton from '../RadioButton/RadioButton';
import { FormattedMessage, useIntl } from 'react-intl';
import { SavedCreditCardsType } from '../../pages/PaymentPage/type';

type SavedCreditCardsPropsType = {
  savedCreditCards: SavedCreditCardsType[];
  choosedCreditCard: SavedCreditCardsType;
  setChoosedCreditCard: Dispatch<React.SetStateAction<SavedCreditCardsType>>;
  handleDeleteCard?: (paymentMethodID: string) => void;
  handleChangeDefaultPaymentMethod?: (paymentMethodID: string) => void;
  isCardCanBeRemoved?: boolean;
};

const SavedCreditCards: React.FC<SavedCreditCardsPropsType> = ({
  savedCreditCards,
  choosedCreditCard,
  setChoosedCreditCard,
  handleDeleteCard,
  handleChangeDefaultPaymentMethod,
  isCardCanBeRemoved,
}) => {
  const [present] = useIonAlert();
  const intl = useIntl();

  useEffect(() => {
    const defaultCard = savedCreditCards && savedCreditCards.find((card) => card.isDefaultPaymentMethod);

    setChoosedCreditCard(defaultCard!);
  }, []);

  const handleSelectChange = async (event: any) => {
    const value = event.target.value;
    const choosedObjectPaymentMethod = savedCreditCards.find(
      (card: SavedCreditCardsType) => card.paymentMethodId === value
    );

    if (choosedObjectPaymentMethod) {
      setChoosedCreditCard(choosedObjectPaymentMethod);
      handleChangeDefaultPaymentMethod && handleChangeDefaultPaymentMethod(choosedObjectPaymentMethod.paymentMethodId);
    }
  };

  const cardList = savedCreditCards.map((card: SavedCreditCardsType) => {
    const cardExpMonth = card.exp_month! < 10 ? '0' + card.exp_month : card.exp_month;

    return (
      <Label key={card.paymentMethodId} isActive={choosedCreditCard?.paymentMethodId === card.paymentMethodId}>
        <SavedCardInfo>
          <RadioButton
            readOnly
            type="radio"
            name="radio"
            value={card.paymentMethodId}
            checked={choosedCreditCard?.paymentMethodId === card.paymentMethodId}
            onClick={(event) => handleSelectChange(event)}
            id={'radio-button'}
          />
          <CardOperatorImageContainer>
            <img src={`./${card.brand}.svg`} alt={card.brand} />
          </CardOperatorImageContainer>
          <div>
            <CardOperatorAndNumber>
              <h4>{card.brand}</h4>
              <h4>
                <span>••••</span>
                {card.last4}
              </h4>
            </CardOperatorAndNumber>
            <CardExpireDate>
              <FormattedMessage id={'card.expired.to'} defaultMessage={'Дійсна до'} /> {cardExpMonth}/
              {card.exp_year!.toString().slice(2, 4)}
            </CardExpireDate>
          </div>
        </SavedCardInfo>
        {isCardCanBeRemoved && (
          <label htmlFor="radio">
            <StyledDeleteIcon
              icon={trashOutline}
              onClick={() =>
                present({
                  mode: 'ios',
                  header: intl.formatMessage({
                    id: 'card.question.delete',
                    defaultMessage: 'Ви точно хочете видалити картку?',
                  }),
                  buttons: [
                    {
                      text: intl.formatMessage({
                        id: 'general.no',
                        defaultMessage: 'Ні',
                      }),
                    },
                    {
                      text: intl.formatMessage({
                        id: 'general.yes',
                        defaultMessage: 'Так',
                      }),
                      handler: () => {
                        handleDeleteCard?.(card.paymentMethodId);
                      },
                    },
                  ],
                })
              }
            />
          </label>
        )}
      </Label>
    );
  });

  return (
    <div>
      <Wrapper>{cardList}</Wrapper>
    </div>
  );
};

export default React.memo(SavedCreditCards);
